import {
  BMCard,
  BMImageContainer,
  BMPrimitives,
  BMText,
} from "@traveloka/district-bloom";
import IcSystemMapLocationFill from "@traveloka/icon-kit-web/react/IcSystemMapLocationFill";
import { Pressable, StyleSheet } from "react-native";
import { RECENTS_SEARCH_IMAGE_NOT_FOUND } from "../../../../assets/not-found";
import BMView from "../../../../components/View/BMView";
import { useHotelAutocomplete } from "../../../../providers/api/HotelAutocompleteContext";
import { RecentSearchHotelPropertyItem } from "../../../../providers/api/RecentlyViewedHotelsContext";

type Props = {
  hotel: RecentSearchHotelPropertyItem;
  onCloseDialog: () => void;
  testID?: string;
};

export default function RecentlyViewedHotel(props: Props) {
  const { hotel, onCloseDialog, testID } = props;
  const { handleSelectSearchItem } = useHotelAutocomplete();
  function handleSelectItem() {
    handleSelectSearchItem({
      id: hotel.hotelId,
      name: hotel.hotelName,
      type: "HOTEL",
    });
    onCloseDialog();
  }

  return (
    <Pressable onPress={handleSelectItem}>
      <BMCard
        testID={testID}
        style={styles.container}
        layout="COMPACT"
        elevation="BOX"
      >
        <BMView row spacing="sm">
          <BMImageContainer
            aspectRatio="AVATAR"
            src={hotel.image || RECENTS_SEARCH_IMAGE_NOT_FOUND}
          />
          <BMView style={styles.details}>
            <BMText
              numberOfLines={2}
              ellipsizeMode="tail"
              ink="BMStyleTextInkPrimary"
              variant="uiLarge"
            >
              {hotel.hotelName}
            </BMText>
            <BMView style={styles.location} spacing="xs" row align="center">
              {hotel.location && (
                <>
                  <IcSystemMapLocationFill width={12} height={12} />
                  <BMText ink="BMStyleTextInkSecondary" variant="uiNormalLi">
                    {hotel.location}
                  </BMText>
                </>
              )}
            </BMView>
          </BMView>
        </BMView>
      </BMCard>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  container: {
    width: 232,
  },
  details: {
    width: 148,
  },
  location: {
    marginTop: BMPrimitives.BMSize.xs,
  },
});
